module.exports = __webpack_public_path__ + "static/media/analog.2c704cbe.jpeg";